import ImageWebp from "./ImageWebp";
import type { WebpProps } from "./ImageWebp";
export type { WebpProps };
export default ImageWebp;
